import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import lngSV from '../translations/sv.json';
import lngEN from '../translations/en.json';
import { LOCALE } from '@config/constants';

export const initI18n = () => {
  if (!i18next.isInitialized) {
    void i18next.use(initReactI18next).init({
      lng: LOCALE,
      keySeparator: false,
      fallbackLng: 'en',
      ns: ['default'],
      defaultNS: 'default',
      returnEmptyString: false,
      resources: {
        sv: {
          default: lngSV,
        },
        en: {
          default: lngEN,
        },
      },
    });
  }
};

export const i18n = i18next;
